var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00789 12.5001L2.21622 5.95008C2.05272 5.66748 1.97583 5.34307 1.99509 5.01715C2.01435 4.69122 2.12891 4.37813 2.32456 4.11675L3.66622 2.33341C3.82147 2.12642 4.02278 1.95842 4.2542 1.8427C4.48563 1.72699 4.74082 1.66675 4.99956 1.66675H14.9996C15.2583 1.66675 15.5135 1.72699 15.7449 1.8427C15.9763 1.95842 16.1776 2.12642 16.3329 2.33341L17.6662 4.11675C17.8632 4.37729 17.9792 4.68995 17.9999 5.01589C18.0207 5.34183 17.9452 5.66668 17.7829 5.95008L13.9912 12.5001",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16758 9.99992L4.26758 1.83325",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 9.99992L15.734 1.83325",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 5.83325H13.3327",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.3333C12.3018 18.3333 14.1673 16.4679 14.1673 14.1667C14.1673 11.8655 12.3018 10 10.0007 10C7.69946 10 5.83398 11.8655 5.83398 14.1667C5.83398 16.4679 7.69946 18.3333 10.0007 18.3333Z",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 14.9999V13.3333H9.58398",
    stroke: "#F8F8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.3ce0a500d70602e7b441e8d985d514ff.svg";
export { ForwardRef as ReactComponent };